<button [disabled]="disabled" mat-stroked-button color="accent" type="button" (click)="deleteFile()">
  <mat-icon color="accent" matPrefix>delete</mat-icon>
  {{ buttonText }}
</button>
